import { getMenuAuth } from "src/apis/authApi";
import {  useCallback, useEffect } from "react";
import useActionbarAuthStore from "src/store/useActionbarAuthStore";
import useMenuGlobalStore from "src/store/useMenuStore";
import { downloadSettingExcel } from "src/utils/blob/blobUtil";
import { useLoadingSpinnerStore } from "src/store/util/loadingSpinnerUtil";
import useFetchActionbarAuth from "src/hooks/useFetchActionbarAuth";
import { ShowSuccessFetch, showWarning } from "src/utils/toast/toastUtil";

import { useKSK2101_R01Store, defaultKSK2101_R01Filter, KSK2101_R01Filter } from "./Store_KSK2101_R01";
import { KSK2101_R01Dto } from "./Dto_KSK2101_R01";
import { fetchDataSetHandler, fetchFilterConfig } from "src/utils/grid/GridHandlerContent";
import { getKSK2101_R01AllCount, getKSK2101_R01List } from "./Api_KSK2101_R01";
import { formatDate } from "src/utils/string/stringUtil";

interface ProductResultContentProps {
    setMessage: (message: string) => void;
}

export const Content_KSK2101_R01 = (props: ProductResultContentProps) => {
    const { setMessage } = props;

    const { 
        KSK2101_R01Filter, setKSK2101_R01Filter,
        KSK2101_R01PastFilter, setKSK2101_R01PastFilter,
        KSK2101_R01List, setKSK2101_R01List, 
        setAllCount,
    } = useKSK2101_R01Store();
    const { setLoadingSpinner } = useLoadingSpinnerStore();
    const setAuth = useActionbarAuthStore((state) => state.setAuth);

    useFetchActionbarAuth("KSK2101_R01");

    useEffect(() => {
        getMenuAuth("KSK2101_R01").then((res) => {
            setAuth(res.data);
        });
    }, []);

    const getParams = (filter: Partial<KSK2101_R01Filter>) => {
		return {
			compCd: filter.compCd,
			workplaceCd: filter.workplaceCd,
			jobTeam: filter.jobTeam,
			dateRange: filter.dateRange,
			startDate: filter.dateRange ? formatDate(filter.dateRange.from) : undefined,
			endDate: filter.dateRange ? formatDate(filter.dateRange.to) : undefined,
			closeTag: filter.closeTag,
			workEmp: filter.workEmp,
			workEmpNm: filter.workEmpNm,
			workCloseShow: filter.workCloseShow,
		}
	}

    const renewalAllCount = useCallback(async () => {
        const response = await getKSK2101_R01AllCount(getParams(KSK2101_R01Filter));
        setAllCount(response.data.data);
        return response.data.data;
    }, [KSK2101_R01Filter, setAllCount]);

    const fetchData = useCallback(async () => {
        setLoadingSpinner(true);
        try {
			
            const response = await getKSK2101_R01List(
                '',
                getParams(KSK2101_R01Filter),
                KSK2101_R01List.length ?? 0
            );

            const rawData = (response.data.data as Omit<KSK2101_R01Dto, 'valueIndex'|'orderIndex'|'orderIndexSeq'>[]).map((row, idx) => ({
                valueIndex: idx,
                orderIndex: idx + 1,
                orderIndexSeq: 0,
                ...row,
            }));

			const newList = [...rawData ] as KSK2101_R01Dto[];
            const processAllCount = await renewalAllCount();

            if (newList && newList.length > 0) {
                setKSK2101_R01PastFilter(KSK2101_R01Filter);
                setKSK2101_R01List(newList);
                ShowSuccessFetch(setMessage, `조회가 완료되었습니다. (총 ${newList.length}/${processAllCount}건)`);
				
            } else {
                showWarning('데이터가 없습니다.');
                setKSK2101_R01List([]);
            }
        } catch (error) {
            console.error('데이터 조회 실패:', error);
            showWarning('데이터 조회에 실패했습니다.');
            setKSK2101_R01List([]);
        } finally {
            setLoadingSpinner(false);
        }
		setTimeout(() => { setMessage(''); }, 5000);
    }, [KSK2101_R01Filter, setKSK2101_R01List, setKSK2101_R01PastFilter]);

    return {
        fetchData,
    };
};


